// Always use the live ID Austria IdP — the swipesign client is only
// registered there. The backend's ID_AUSTRIA_TOKEN_ENDPOINT must point at
// the same (live) IdP for the code exchange to succeed.
const AUTH_ENDPOINT =
  'https://eid.oesterreich.gv.at/auth/idp/profile/oidc/authorize';

const CLIENT_ID = 'https://app.swipesign.xyz';

const initiateIDAustriaLogin = () => {
  const redirectUri = `${window.location.origin}/auth/register/idaustria/callback`;
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: CLIENT_ID,
    scope: 'openid profile',
    redirect_uri: redirectUri,
  });

  window.location.href = `${AUTH_ENDPOINT}?${params.toString()}`;
};

export default initiateIDAustriaLogin;
